import { InternalPlanPurchaseFormContext } from '../PlanPurchaseForm/context/InternalPlanPurchaseFormContext'
import { PlanPurchaseFormContextProps } from './PlanPurchaseFormContextProps'
import { useContext, useMemo } from 'react'

/**
 * Provides data controlled and calculated by the PlanPurchaseForm
 * so that individual implementations have less re-work and more focus
 * on their UX.
 */
export function usePlanPurchaseFormContext(): PlanPurchaseFormContextProps {
  const context = useContext(InternalPlanPurchaseFormContext)
  if (!context) {
    throw new Error('usePlanPurchaseFormContext must be used within a PlanPurchaseForm')
  }

  const { paymentMethodType, promo } = context
  return useMemo(() => {
    return {
      paymentMethodType,
      promo
    }
  }, [paymentMethodType, promo])
}
